import { render } from "./AdvertBanner.vue?vue&type=template&id=49cd37f2&scoped=true"
import script from "./AdvertBanner.vue?vue&type=script&lang=js"
export * from "./AdvertBanner.vue?vue&type=script&lang=js"

import "./AdvertBanner.vue?vue&type=style&index=0&id=49cd37f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cd37f2"]])

export default __exports__